(function () {
  var SEL = '.mlp .mig-g, .mlp .mst-g, .mme .mme-3, .mrv .mrv-grid';

  function build(el) {
    if (el.dataset.mcar) return;
    var n = el.children.length;
    if (n < 2) return;
    el.dataset.mcar = '1';

    var nav = document.createElement('div');
    nav.className = 'mcar-nav';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'mcar-b'; prev.textContent = '‹';
    prev.setAttribute('aria-label', 'Anterior');
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'mcar-b'; next.textContent = '›';
    next.setAttribute('aria-label', 'Siguiente');
    var info = document.createElement('span');
    info.className = 'mcar-i';
    nav.appendChild(prev); nav.appendChild(info); nav.appendChild(next);
    el.parentNode.insertBefore(nav, el.nextSibling);

    function index() {
      var mid = el.scrollLeft + el.clientWidth / 2;
      var best = 0, bd = Infinity;
      for (var i = 0; i < el.children.length; i++) {
        var c = el.children[i];
        var cc = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(cc - mid);
        if (d < bd) { bd = d; best = i; }
      }
      return best;
    }

    function sync() {
      var i = index();
      info.innerHTML = '<b>' + (i + 1) + '</b>/' + n;
      prev.disabled = el.scrollLeft <= 2;
      next.disabled = el.scrollLeft >= el.scrollWidth - el.clientWidth - 2;
    }

    function go(dir) {
      var i = Math.min(Math.max(index() + dir, 0), n - 1);
      var c = el.children[i];
      el.scrollTo({ left: c.offsetLeft - (el.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var t;
    el.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(sync, 60);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(sync, 120);
    });

    sync();
  }

  function init(root) {
    (root || document).querySelectorAll(SEL).forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
